import Enum from './enum'

/**
 * 実施題材マスタ コメント機能
 */
class OptionComment extends Enum {
    static WHOLE_SCHOOL = 1; // 学年全体許可
    static IN_CLASS = 2; // クラス内のみ許可
    static NONE = 9; // なし

    static values() {
        return {
            [this.WHOLE_SCHOOL]: '学年全体許可',
            [this.IN_CLASS]: 'クラス内のみ許可',
            [this.NONE]: 'なし',
        }
    }

    //作品写真の児童間共有が「なし」の場合に、disabledにする値
    static keysCanBeDisabled() {
        return [
            this.WHOLE_SCHOOL,
            this.IN_CLASS,
        ]
    }
}

export default OptionComment;
